import { CustomerServiceTag, QuoteApiModel, QuoteOptionApiModel } from '~/lib/api/smartsend/types';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';
import { QuoteResult } from '../QuoteResult';
import { CurrentSelectionType } from '../utils/CurrentSelectionType';
import { P2GLinkGroup } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { QuoteLayoutColumnHeader } from './QuoteLayoutColumnHeader';
import { ServiceSpeedType } from '../utils/PopulateQuoteTags';
import { QuoteTagType } from '../utils/QuoteTagType';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { QuoteLayoutVariant } from './QuoteLayoutVariant';

interface props {
  onSave?: (quote: QuoteApiModel, option: QuoteOptionApiModel) => void;
  quotes: QuoteApiModel[];
  currentSelection: CurrentSelectionType;
  estimatedValue?: number;
  quoteTagType: QuoteTagType;
  updateServiceTags: (add: CustomerServiceTag[], remove: CustomerServiceTag[]) => void;
  serviceTags: CustomerServiceTag[];
  serviceType: ServiceSpeedType;
  index: number;
  editMode: boolean;
  includeServices: (quotes: QuoteApiModel[]) => void;
  excludeServices: (quotes: QuoteApiModel[]) => void;
  toggleSpecificTag: (tag: CustomerServiceTag) => void;
  maxQuoteOptions: number;
  isXs: boolean;
  children?: React.ReactNode;
  showHeader: boolean;
  variant: QuoteLayoutVariant;
}

export const QuoteLayoutColumn: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  if (props.quotes.length === 0) {
    return null;
  }

  return (
    <P2GGrid item md={4} xs={12}>
      {props.showHeader && (
        <QuoteLayoutColumnHeader
          serviceType={props.serviceType}
          index={props.index}
          currentSelection={props.currentSelection}
        />
      )}
      {props.editMode && (
        <P2GBox textAlign="center" pb={1}>
          <P2GLinkGroup
            links={[
              <P2GLink onClick={() => props.includeServices(props.quotes)}>
                {t('ADD_BUTTON', { defaultValue: 'Add' })}
              </P2GLink>,
              <P2GLink onClick={() => props.excludeServices(props.quotes)}>
                {t('REMOVE_BUTTON', { defaultValue: 'Remove' })}
              </P2GLink>
            ]}
          />
        </P2GBox>
      )}
      {props.quotes.map((s, i) => (
        <QuoteResult
          variant={props.variant}
          isXs={props.isXs}
          maxQuoteOptions={props.maxQuoteOptions}
          toggleSpecificTag={props.toggleSpecificTag}
          index={i}
          key={s.Service.Id}
          updateServiceTags={props.updateServiceTags}
          quote={s}
          estimatedValue={props.estimatedValue}
          onSave={props.onSave}
          currentSelection={props.currentSelection}
          serviceTags={props.serviceTags.find((x) => x.ServiceSlug === s.Service.Id)?.Tags || []}
          editMode={props.quoteTagType}
        />
      ))}
    </P2GGrid>
  );
};
